module.exports = __webpack_public_path__ + "lv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lv.svg
// module id = 672
// module chunks = 0